
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Loading } from "../../../../componentes/loading/loading";
import { formatarMoedaBrasileira } from "../../../../utils/formatarMoedaBrasileira";

export default function ResumoPorFilial({ data, filtrar, loading, alterarFilial }) {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [labels, setLabels] = useState([]);

  useEffect(() => {
    if (data.resultadoSomaDTO?.porFilial) {
      const filiais = Object.keys(data.resultadoSomaDTO.porFilial);
      const valores = Object.values(data.resultadoSomaDTO.porFilial);

      setLabels(filiais);

      setChartOptions({
        chart: {
          type: "donut",
          toolbar: { show: true },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const index = config.dataPointIndex;
              const label = filiais[index];
              alterarFilial(label);
            }
          }
        },
        labels: filiais,
        legend: {
          position: "bottom",
          fontSize: "14px"
        },
        tooltip: {
          y: {
            formatter: (value) => `Valor Gasto: R$ ${formatarMoedaBrasileira(value)}`
          }
        },
        stroke: {
          show: false,
          width: 0
        },
        colors: [
          "#3B82F6",
          "#F97316",
          "#22C55E",
          "#393b57ff",
          "#c52294ff",
          "#805068ff",
          "#daf108ff"
        ]
      });

      setChartSeries(valores);
    } else {
      setChartSeries([]);
    }
  }, [data, filtrar]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:col-span-1 lg:min-h-[423px]">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Solicitações por Filial
      </h3>
      <label className="text-muted-foreground text-sm">
        Distribuição das solicitações entre as unidades da empresa.
      </label>
     
        {!loading ? (
          data.solicitacoes.length > 0 && chartSeries.length > 0 ? (
            <Chart
              options={chartOptions}
              series={chartSeries}
              type="donut"
                height={280}
            />
          ) : (
            "Não existem dados disponíveis para o intervalo selecionado."
          )
        ) : (
          <Loading />
        )}
      
    </div>
  );
}
